import React from 'react';

import { CasinoGameList } from '@swf/casino';
import type { CasinoGameList as CasinoGameListProps } from '@swf/core/types/CasinoGameList';

import NoAvailableFavorites from './components/NoAvailableFavorites/NoAvailableFavorites';

export type Props = CasinoGameListProps;

const CasinoFavouritesList: React.FC<Props> = (props) =>
  props.favouriteIcon && !props.games.length ? (
    <NoAvailableFavorites />
  ) : (
    <CasinoGameList {...props} />
  );
export default CasinoFavouritesList;
